import * as z from "zod/v4";

const productTypeSchema = z.enum([
  "returns",
  "order-editing",
  "oms",
  "email-sms",
  "conversion",
  "support-ai",
]);

const assigneeSchema = z.object({
  email: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  department: z.string().optional(),
  name: z.string().optional(),
});

const lookupSchema = z.object({
  merchantId: z.string(),
  product: productTypeSchema,
});

const assigneeResultSchema = z.object({
  merchantId: z.string(),
  product: productTypeSchema,
  assignees: z.array(assigneeSchema),
});

export const getOnboardingAssignees = {
  name: "getOnboardingAssignees" as const,
  input: z.object({ lookups: z.array(lookupSchema) }),
  output: z.object({ results: z.array(assigneeResultSchema) }),
};

export type ProductType = z.infer<typeof productTypeSchema>;
export type Assignee = z.infer<typeof assigneeSchema>;
export type AssigneeLookup = z.infer<typeof lookupSchema>;
export type AssigneeResult = z.infer<typeof assigneeResultSchema>;
export type GetOnboardingAssigneesInput = z.infer<
  typeof getOnboardingAssignees.input
>;
export type GetOnboardingAssigneesOutput = z.infer<
  typeof getOnboardingAssignees.output
>;
